export function getPrimaryColor(): string {
    const rootStyles = getComputedStyle(document.documentElement);
    const primaryColor = rootStyles.getPropertyValue('--primaryColor');
    return primaryColor;
}
